import React from "react";
import { Link, useParams } from "react-router-dom";
import { useDirection } from "hooks/useDirection";
import CourseChatPanel from "components/chat/CourseChatPanel";

export default function AdminCourseChatPage() {
  const { courseId } = useParams();
  const { isArabic } = useDirection();

  if (!courseId) return null;

  return (
    <div className="flex flex-col gap-4 p-2">
      <Link to="/admin/entities" className="text-sm text-brand-500 hover:underline">
        {isArabic ? "← العودة للكورسات" : "← Back to courses"}
      </Link>
      <CourseChatPanel courseId={courseId} scope="admin" />
    </div>
  );
}
